export { default as BaseIcon } from './_base-icon.vue';
